import { TResApi } from '@src/configs/interface.config'
import { checkAuth } from '@src/libs/localStorage'
import {
  TActiveUsersResponse,
  TActiveUsersSnapshot,
  TAnalyticsOverview,
  TPostEngagementOverview,
  TPostEngagementTopItem,
  TPostEngagementViewsSeriesResponse,
  TQueryActiveUsers,
  TQueryActiveUsersSnapshot,
  TQueryPostEngagementTop,
  TQueryPostEngagementViewsSeries,
} from '@src/modules/analytics'
import { useQuery } from 'react-query'

import {
  getActiveUsers,
  getActiveUsersSnapshot,
  getAnalyticsOverview,
  getPostEngagementOverview,
  getPostEngagementTopPosts,
  getPostEngagementViewsSeries,
} from '../apis/analytics'
import {
  ANALYTICS_ACTIVE_USERS,
  ANALYTICS_OVERVIEW,
  ANALYTICS_SNAPSHOT,
  POST_ENGAGEMENT_OVERVIEW,
  POST_ENGAGEMENT_TOP_POSTS,
  POST_ENGAGEMENT_VIEWS_SERIES,
} from '../keys/analytics'

export const useQueryAnalyticsOverview = (token?: string) => {
  const accessToken = token || checkAuth()
  return useQuery<TResApi<TAnalyticsOverview>>([ANALYTICS_OVERVIEW], () => getAnalyticsOverview(accessToken), {
    enabled: !!accessToken,
  })
}

export const useQueryActiveUsers = (params: TQueryActiveUsers, token?: string) => {
  const accessToken = token || checkAuth()
  return useQuery<TResApi<TActiveUsersResponse>>(
    [ANALYTICS_ACTIVE_USERS, params.from, params.to, params.period || 'daily'],
    () => getActiveUsers(params, accessToken),
    { enabled: !!accessToken && !!params.from && !!params.to },
  )
}

export const useQueryActiveUsersSnapshot = (params: TQueryActiveUsersSnapshot, token?: string) => {
  const accessToken = token || checkAuth()
  return useQuery<TResApi<TActiveUsersSnapshot>>(
    [ANALYTICS_SNAPSHOT, params.from, params.to],
    () => getActiveUsersSnapshot(params, accessToken),
    { enabled: !!accessToken && !!params.from && !!params.to },
  )
}

export const useQueryPostEngagementOverview = (token?: string) => {
  const accessToken = token || checkAuth()
  return useQuery<TResApi<TPostEngagementOverview>>(
    [POST_ENGAGEMENT_OVERVIEW],
    () => getPostEngagementOverview(accessToken),
    { enabled: !!accessToken },
  )
}

export const useQueryPostEngagementTopPosts = (params: TQueryPostEngagementTop, token?: string) => {
  const accessToken = token || checkAuth()
  return useQuery<TResApi<TPostEngagementTopItem[]>>(
    [POST_ENGAGEMENT_TOP_POSTS, params.sortBy ?? 'views', params.limit ?? 10],
    () => getPostEngagementTopPosts(params, accessToken),
    { enabled: !!accessToken },
  )
}

export const useQueryPostEngagementViewsSeries = (params: TQueryPostEngagementViewsSeries, token?: string) => {
  const accessToken = token || checkAuth()
  return useQuery<TResApi<TPostEngagementViewsSeriesResponse>>(
    [POST_ENGAGEMENT_VIEWS_SERIES, params.from, params.to],
    () => getPostEngagementViewsSeries(params, accessToken),
    { enabled: !!accessToken && !!params.from && !!params.to },
  )
}
